import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.5 11.134C21.1667 11.5189 21.1667 12.4811 20.5 12.866L7 20.6603C6.33334 21.0452 5.5 20.564 5.5 19.7942L5.5 4.20577C5.5 3.43597 6.33333 2.95485 7 3.33975L20.5 11.134Z",
		fill: "black"
	})
});
export default SvgIconPlay;
